import { Fade, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import NoDataImage from '../../assets/images/No-Data.png'
import { Ticket } from '../../helpers/ticketWorkflow'
import { getTranslate } from '../../localization'
import SupportQueueRow from './SupportQueueRow'
import SupportQueueRowSkeleton from './SupportQueueRow.skeleton'
import useStyles from './styles/SupportQueueTable.styles'

interface SupportQueueTableProps {
  tickets: Ticket[]
  loading: boolean
  settled: boolean
  /**
   * What an empty list MEANS. Only the parent knows whether a search is
   * narrowing it, and "nothing here" and "nothing matched" are different
   * facts — telling an operator the first when the second is true is a lie
   * the search itself created.
   */
  emptyMessage: string
  reloadData: () => void
}

export default function SupportQueueTable({
  tickets,
  loading,
  settled,
  emptyMessage,
  reloadData
}: SupportQueueTableProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Number')}</Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate('Reporter entity')}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Title')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('State')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Assignment')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Updated')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton onClick={reloadData} aria-label={getTranslate('Refresh')}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>

      {loading && !tickets.length
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <SupportQueueRowSkeleton
                key={`support-queue-skeleton${item}${index.toString()}`}
              />
            ))
        : tickets.map((ticket) => (
            <Fade in timeout={600} key={ticket.id}>
              <div data-cy="tableRowSupportQueueData">
                <SupportQueueRow ticket={ticket} />
              </div>
            </Fade>
          ))}

      {settled && !tickets.length && (
        <div className={classes.noDataImageContainer}>
          <img src={NoDataImage} alt={emptyMessage} />
        </div>
      )}
    </div>
  )
}
